<template>
    <v-container fluid class="mb-5 px-0 cl-filters">
        <v-row align="center" justify="center">
            <v-expansion-panels v-model="panel" multiple>
                <v-expansion-panel class="cl-filters__panel">
                    <v-expansion-panel-header class="cl-filters__header py-0">
                        <v-row justify="start">
                            <v-col cols="12" md="2" align="start">
                                <v-icon class="cl-filters__icon mr-2">mdi-tune-variant</v-icon>
                                Φίλτρα
                            </v-col>
                        </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <!-- all the filters on one line of a wide screen, two per line on a phone -->
                        <div class="cl-filters__grid">
                            <v-select
                                v-model="season"
                                color="teal"
                                item-color="teal"
                                label="Σεζόν"
                                :items="seasons"
                                item-text="name"
                                dark
                                hide-details
                                return-object
                            />
                            <!-- none for the cup: it has no phases -->
                            <v-select
                                v-if="phaseOptions.length"
                                v-model="phase"
                                label="Φάση"
                                color="teal"
                                item-color="teal"
                                :items="phaseOptions"
                                item-text="title"
                                item-value="value"
                                dark
                                hide-details
                                @change="league ? getRankingByLeague() : null"
                            />
                            <v-select
                                v-model="league"
                                color="teal"
                                item-color="teal"
                                :items="hasCup ? leagues.concat('Cup') : leagues"
                                label="League"
                                item-text="title"
                                return-object
                                item-value="id"
                                clearable
                                dark
                                hide-details
                            />
                            <v-text-field
                                v-if="$route.name === 'Schedule'"
                                v-model="round"
                                :disabled="!league"
                                color="teal"
                                label="Αγωνιστική"
                                :placeholder="league ? 'π.χ. 3' : 'Διάλεξε πρώτα league'"
                                type="number"
                                min="1"
                                clearable
                                dark
                                hide-details
                            />
                            <v-select
                                v-if="$route.name === 'Schedule'"
                                v-model="arena"
                                color="teal"
                                item-color="teal"
                                label="Γήπεδο"
                                :items="arenas"
                                item-text="name"
                                item-value="id"
                                return-object
                                clearable
                                dark
                                hide-details
                            />
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-row>
    </v-container>
</template>

<script>
    import seasonService from '@/services/season.js'
    import leagueService from '@/services/league.js'
    import arenaService from '@/services/arena'
    import moment from 'moment'
    import { availablePhases, pickPhase } from '@/utils/phases'

    const PHASE_OPTIONS = [
        { title: 'Regular Season', value: 'regular_season' },
        { title: 'PlayOffs', value: 'playoffs' }
    ]

    export default {
        props: {
            cup: {
                type: Boolean,
                deafult: true
            }
        },
        data() {
            return {
                panel: [0],
                season: null,
                league: null,
                arena: null,
                round: null,
                seasons: [],
                leagues: [],
                teams: [],
                filter: {},
                arenas: [],
                phase: 'regular_season',
                // what the season has to show (null: unknown, all the options), and the season it is of
                seasonPhases: null,
                seasonPhasesId: null
            }
        },
        computed: {
            // only the phases of the league with matches (the playoffs also with a bracket)
            phaseOptions() {
                return availablePhases(PHASE_OPTIONS, this.seasonPhases, this.league)
            },
            hasCup() {
                return this.cup && (!this.seasonPhases || this.seasonPhases.cup)
            },
            activePhase() {
                const config = this.$store.getters.getConfig
                return config && config.activePhase ? config.activePhase : null
            }
        },
        watch: {
            // '$route'(to, from) {
            //     if (to !== from) {
            //         new Promise((resolve) => { resolve(this.init()) }).then(() => {
            //             this.getByFilters()
            //         })
            //     }
            // },
            season: {
                handler(value, previous) {
                    // another season: what is on screen is not of it any more
                    if (previous) {
                        this.$emit('clear')
                        // its leagues come with the season
                        this.leagues = []
                        this.league = null
                    }
                    if (value) {
                        this.$store.dispatch('setLeagueFilter', null)
                        this.$store.dispatch('setSeasonFilter', value)
                        this.filter = null
                        this.fetchSeasonPhases(value)
                        this.fetchAllLeagues()
                    }
                    this.getByFilters()
                }
            },
            league: {
                handler(value) {
                    if (value) {
                        this.$store.dispatch('setLeagueFilter', value)
                        this.filter = null
                    }
                    this.getByFilters()
                }
            },
            arena: {
                handler(value) {
                    if (value) {
                        this.$store.dispatch('setLeagueFilter', null)
                        this.filter = null
                    }
                    this.getByFilters()
                }
            },
            round: {
                handler(value) {
                    if (value) {
                        this.$store.dispatch('setLeagueFilter', null)
                        this.filter = null
                    }
                    this.getByFilters()
                }
            },
            phaseOptions() {
                this.fixPhase()
            }
        },
        created() {
            this.init()
        },
        methods: {
            fetchSeasonPhases(season) {
                this.seasonPhasesId = null
                const done = (phases) => {
                    if (!this.season || this.season.id !== season.id) return
                    this.seasonPhases = phases
                    this.seasonPhasesId = season.id
                    this.fixPhase()
                    this.getByFilters()
                }
                seasonService.getPhases(season.id).then(resp => done(resp.data || null)).catch(() => done(null))
            },
            // a phase (or the cup) with nothing to show is not an option: on to one that has
            fixPhase() {
                if (this.league === 'Cup' && !this.hasCup) {
                    this.league = this.leagues[0] || null
                }
                const phase = pickPhase(this.phase, this.phaseOptions, this.activePhase)
                if (phase !== this.phase) {
                    this.phase = phase
                    this.getByFilters()
                }
            },
            init() {
                this.fetchAllSeasons()
                this.fetchAllArenas()
                if (this.$store.getters.getSeasonFilter) {
                    this.season = this.$store.getters.getSeasonFilter
                }
                if (this.$store.getters.getLeagueFilter) {
                    this.league = this.$store.getters.getLeagueFilter
                    // if (this.$route.name === 'Standings') {
                    //     this.getRankingByLeague()
                    // }
                }
            },
            getRankingByLeague() {
                if (this.league === 'Cup') {
                    this.$emit('getCupState', true)
                } else if (this.phase === 'playoffs') {
                    this.$emit('getCupState', false, this.league.id, this.season.id)
                } else {
                    if (this.$route.name === 'Standings') {
                        this.$emit('getRankingByLeague', this.league.id, this.season.id, this.phase)
                    } else if (this.$route.name === 'Schedule') {
                        this.$emit('getScheduleByLeague', this.round, this.arena ? this.arena.id : null, this.league === 'Cup', this.league ? this.league.id : null, this.season ? this.season.id : null, this.phase ? this.phase : null)
                    }
                }
            },
            getByFilters() {
                // the phases of the season first: the phase may not be an option
                if (!this.season || this.seasonPhasesId !== this.season.id) {
                    return
                }
                if (this.$route.name === 'Standings') {
                    if (this.season !== null && this.arenas.length > 0 && (this.leagues.length > 0 || this.league === 'Cup')) {
                        this.getRankingByLeague()
                    }
                } else {
                    if (this.season !== null && this.arenas.length > 0 && (this.leagues.length > 0 || this.league === 'Cup')) {
                        this.$emit('getByFilters', this.round, this.arena ? this.arena.id : null, this.league === 'Cup', this.league ? this.league.id : null, this.season ? this.season.id : null, this.phase ? this.phase : null)
                    }
                }
            },
            fetchAllSeasons() {
                // the active season (and phase) of the CMS, the season of today's date when none is set
                const config = this.$store.dispatch('ensureConfig').catch(() => null)
                Promise.all([seasonService.getSeasons(1, 100), config]).then(([resp, settings]) => {
                    this.seasons = resp.data.content
                    if (this.season) return
                    const active = settings && settings.activeSeasonId ? this.seasons.find(element => element.id === settings.activeSeasonId) : null
                    if (settings && settings.activePhase) {
                        this.phase = settings.activePhase
                    }
                    this.season = active || this.seasons.filter(element => moment().isBetween(moment(element.startDate), moment(element.endDate)))[0]
                })
            },
            fetchAllLeagues() {
                // the leagues of the season in any phase: the phase is picked after the league
                const season = this.season
                leagueService.getLeagues(1, 100, season, null).then(resp => {
                    if (this.season !== season) return
                    this.leagues = resp.data
                    this.league = this.$store.getters.getLeagueFilter ? this.$store.getters.getLeagueFilter : (this.leagues[0] || (this.hasCup ? 'Cup' : null))
                    // if (this.$route.name === 'Standings') {
                    //     this.getRankingByLeague()
                    // } else {
                    //     this.getByFilters()
                    // }
                })
            },
            fetchAllArenas() {
                arenaService.getArenas(1, 100).then(resp => {
                    this.arenas = resp.data.content
                })
            }
        }
    }
</script>

<style>
.v-select__selection--comma {
    font-weight: 600 !important;
}

.v-select {
    font-family: Arial, sans-serif !important;
    font-weight: 600;
}

.v-text-field {
    font-family: Arial, sans-serif !important;
    font-weight: 600;
}

.v-list-item {
    font-family: Arial, sans-serif !important;
    font-weight: 600;
}

.v-list-item__title {
    white-space: normal !important;
}
</style>

<style scoped>
.cl-filters__panel {
    border-radius: 10px !important;
    background: #232323 !important;
    color: #fff !important;
    box-shadow: 0 8px 24px rgba(35, 35, 35, 0.14) !important;
    overflow: hidden;
}

.cl-filters__panel::before {
    box-shadow: none !important;
}

.cl-filters__panel::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 3px;
    border: 0 !important;
    opacity: 1 !important;
    background: linear-gradient(90deg, #03e5b7 0%, #037ade 74%);
}

.cl-filters__header {
    font-family: 'Squada One', 'Roboto Condensed', Arial, sans-serif;
    font-size: 1.4rem;
    letter-spacing: 0.03em;
    text-transform: uppercase;
}

.cl-filters__icon {
    color: #03e5b7 !important;
}

.text-h6 {
    font-size: 1.25rem !important;
    letter-spacing: 0.0125em !important;
    line-height: 2rem;
    font-family: Arial, sans-serif !important;
}

.cl-filters__grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
    gap: 14px 22px;
    padding: 4px 0 10px;
}

@media (max-width: 600px) {
    .cl-filters__grid {
        grid-template-columns: 1fr 1fr;
    }
}

</style>
